import { Routes } from '@angular/router';
import { AuthGuard } from '../../_helper/auth.guard';
import { Role } from '../../_models/role';
const userRole = sessionStorage.getItem('userRole')

export const content: Routes = [
  {
    path: 'adminhkbkcms/dashboard',
    loadChildren: () => import('../../components/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuard],
    data: {
      // // roles: [userRole.search('Dashboard') != -1 ? Role.Dashboard : '']
    }
  },
  {
    path: 'adminhkbkcms/testimonials',
    loadChildren: () => import('../../components/testimonials/testimonials.module').then(m => m.TestimonialsModule),
    data: {
      breadcrumb: "Master",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/aboutbrowseby',
    loadChildren: () => import('../../components/browsebyabout/browsebyabout.module').then(m => m.BrowsebyaboutModule),
    data: {
      breadcrumb: "Master",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/how-to-apply',
    loadChildren: () => import('../../components/how-to-apply/how-to-apply.module').then(m => m.HowToApplyModule),
    data: {
      breadcrumb: "Admissions",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/news-year',
    loadChildren: () => import('../../components/news-year/news-year.module').then(m => m.NewsYearModule),
    data: {
      breadcrumb: "News-Year",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/blogs',
    loadChildren: () => import('../../components/blogs/blogs.module').then(m => m.BlogsModule),
    data: {
      breadcrumb: "Blogs",
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/training-development',
    loadChildren: () => import('../../components/training-development/training-development.module').then(m => m.TrainingDevelopmentModule),
    data: {
      breadcrumb: "Training Development",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/news-categories',
    loadChildren: () => import('../../components/news-categories/news-categories.module').then(m => m.NewsCategoriesModule),
    data: {
      breadcrumb: "News-Categories",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/training-vendors',
    loadChildren: () => import('../../components/training-vendors/training-vendors.module').then(m => m.TrainingVendorsModule),
    data: {
      breadcrumb: "Training Vendors",
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/training-domains-heading',
    loadChildren: () => import('../../components/training-domains-heading/training-domains-heading.module').then(m => m.TrainingDomainsHeadingModule),
    data: {
      breadcrumb: "Training Domains Heading",
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/training-domains-content',
    loadChildren: () => import('../../components/training-domains-content/training-domains-content.module').then(m => m.TrainingDomainsContentModule),
    data: {
      breadcrumb: "Training Domains Content",
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/lifehkbkoverview',
    loadChildren: () => import('../../components/lifehkbkoverview/lifehkbkoverview.module').then(m => m.LifehkbkoverviewModule),
    data: {
      breadcrumb: "Life @ HKBK Overview",
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/getmore',
    loadChildren: () => import('../../components/get-more/get-more.module').then(m => m.GetMoreModule),
    data: {
      breadcrumb: "Get More",
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/studentlife',
    loadChildren: () => import('../../components/studentlife/studentlife.module').then(m => m.StudentlifeModule),
    data: {
      breadcrumb: "Student Life",
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/preplacement-training',
    loadChildren: () => import('../../components/preplacement-training/preplacement-training.module').then(m => m.PreplacementTrainingModule),
    data: {
      breadcrumb: "Preplacement Training",
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/indian-students',
    loadChildren: () => import('../../components/indian-students/indian-students.module').then(m => m.IndianStudentsModule),
    data: {
      breadcrumb: "Admissions",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/nss',
    loadChildren: () => import('../../components/nss/nss.module').then(m => m.NssModule),
    data: {
      breadcrumb: "Life @ HKBK Overview",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/innovation',
    loadChildren: () => import('../../components/innovation/innovation.module').then(m => m.InnovationModule),
    data: {
      breadcrumb: "Research & Innovation",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/sports-adventure',
    loadChildren: () => import('../../components/sports-adventure/sports-adventure.module').then(m => m.SportsAdventureModule),
    data: {
      breadcrumb: "Life @ HKBK Overview",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/human-resources',
    loadChildren: () => import('../../components/human-resources/human-resources.module').then(m => m.HumanResourcesModule),
    data: {
      breadcrumb: "Admissions",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/clubs',
    loadChildren: () => import('../../components/clubs/clubs.module').then(m => m.ClubsModule),
    data: {
      breadcrumb: "Admissions",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/careers',
    loadChildren: () => import('../../components/careers/careers.module').then(m => m.CareersModule),
    data: {
      breadcrumb: "Admissions",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/international-students',
    loadChildren: () => import('../../components/international-students/international-students.module').then(m => m.InternationalStudentsModule),
    data: {
      breadcrumb: "Admissions",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  /* {
    path: 'adminhkbkcms/colleges',
    loadChildren: () => import('../../components/colleges/colleges.module').then(m => m.CollegesModule),
    data: {
      breadcrumb: "Master"
    }
  }, */
  /* {
    path: 'adminhkbkcms/collegeinfo',
    loadChildren: () => import('../../components/products/products.module').then(m => m.ProductsModule),
    data: {
      breadcrumb: "Collegeinfo",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  }, */
  /* {
    path: 'adminhkbkcms/sales',
    loadChildren: () => import('../../components/sales/sales.module').then(m => m.SalesModule),
    data: {
      breadcrumb: "Sales",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/coupons',
    loadChildren: () => import('../../components/coupons/coupons.module').then(m => m.CouponsModule),
    data: {
      breadcrumb: "Coupons"
    },
    canActivate: [AuthGuard],
  }, */
  {
    path: 'adminhkbkcms/pages',
    loadChildren: () => import('../../components/pages/pages.module').then(m => m.PagesModule),
    data: {
      breadcrumb: "Pages",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/sections',
    loadChildren: () => import('../../components/section/section.module').then(m => m.SectionModule),
    data: {
      breadcrumb: "Sections",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  /* {
    path: 'adminhkbkcms/placementsnews',
    loadChildren: () => import('../../components/placementsnews/placementsnews.module').then(m => m.PlacementsnewsModule),
    data: {
      breadcrumb: "Placements News",
    },
    canActivate: [AuthGuard],
  }, */
  {
    path: 'adminhkbkcms/news',
    loadChildren: () => import('../../components/news/news.module').then(m => m.NewsModule),
    data: {
      breadcrumb: "News",
      // roles: [Role.Admin, Role.Placement]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/course',
    loadChildren: () => import('../../components/courses/course.module').then(m => m.CourseModule),
    data: {
      breadcrumb: "Course",
      // roles: [Role.Admin, Role.CivilEngineering, Role.ComputerScienceEngineering, Role.Degree, Role.ElectronicsEngineering, Role.InformationScienceEngineering, Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/fees',
    loadChildren: () => import('../../components/fees/fees.module').then(m => m.FeesModule),
    data: {
      breadcrumb: "Fees",
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/fee',
    loadChildren: () => import('../../components/fee/fee.module').then(m => m.FeeModule),
    data: {
      breadcrumb: "Fee",
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/overview',
    loadChildren: () => import('../../components/overview/overview.module').then(m => m.OverviewModule),
    data: {
      breadcrumb: "Overview",
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/beyond',
    loadChildren: () => import('../../components/beyond/beyond.module').then(m => m.BeyondModule),
    data: {
      breadcrumb: "Beyond",
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard],
  },
   {
    path: 'adminhkbkcms/future',
    loadChildren: () => import('../../components/future/future.module').then(m => m.FutureModule),
    data: {
      breadcrumb: "Future",
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/programs',
    loadChildren: () => import('../../components/programs/programs.module').then(m => m.ProgramsModule),
    data: {
      breadcrumb: "Programs",
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/curriculum',
    loadChildren: () => import('../../components/curriculum/curriculum.module').then(m => m.CurriculumModule),
    data: {
      breadcrumb: "Curriculum",
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/eligibility',
    loadChildren: () => import('../../components/eligibility/eligibility.module').then(m => m.EligibilityModule),
    data: {
      breadcrumb: "Eligibility",
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/moredetails',
    loadChildren: () => import('../../components/moredetails/moredetails.module').then(m => m.MoredetailsModule),
    data: {
      breadcrumb: "Moredetails",
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/recruiters',
    loadChildren: () => import('../../components/placements/placements.module').then(m => m.PlacementsModule),
    data: {
      breadcrumb: "Recruiters",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/homecontents',
    loadChildren: () => import('../../components/homebannermenu/homebannermenu.module').then(m => m.HomebannermenuModule),
    data: {
      breadcrumb: "Home",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  
  /* {
    path: 'adminhkbkcms/advancedengineering',
    loadChildren: () => import('../../components/advancedengineering/advancedengineering.module').then(m => m.AdvancedengineeringModule),
    data: {
      breadcrumb: "Home"
    },
    canActivate: [AuthGuard],
  }, */
  {
    path: 'adminhkbkcms/institutions',
    loadChildren: () => import('../../components/institutions/institutions.module').then(m => m.InstitutionsModule),
    data: {
      breadcrumb: "Institutions",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/placements-overview',
    loadChildren: () => import('../../components/hkbkplacements/hkbkplacements.module').then(m => m.HkbkplacementsModule),
    data: {
      breadcrumb: "Placements Overview",
      // roles: [Role.Admin, Role.Placement]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/placements-otherinfo',
    loadChildren: () => import('../../components/hkbkplacements-otherinfo/hkbkplacements-otherinfo.module').then(m => m.PlacementsOtherinfoModule),
    data: {
      breadcrumb: "Placements Otherinfo",
      // roles: [Role.Admin, Role.Placement]
    },
    canActivate: [AuthGuard],
  },
  /* {
    path: 'adminhkbkcms/academics',
    loadChildren: () => import('../../components/academics/academics.module').then(m => m.AcademicsModule),
    data: {
      breadcrumb: "Academics"
    },
    canActivate: [AuthGuard],
  }, */
  {
    path: 'adminhkbkcms/faculty',
    loadChildren: () => import('../../components/faculty/faculty.module').then(m => m.FacultyModule),
    data: {
      breadcrumb: "Faculty",
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/students-placed',
    loadChildren: () => import('../../components/hkbkplacements-students-placed/hkbkplacements-students-placed.module').then(m => m.PlacementsStudentsPlacedModule),
    data: {
      breadcrumb: "Students Placed",
      // roles: [Role.Admin, Role.Placement]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/aboutusoverview',
    loadChildren: () => import('../../components/aboutus-overview/aboutus-overview.module').then(m => m.AboutusOverviewModule),
    data: {
      breadcrumb: "About Us Overview",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/rankings',
    loadChildren: () => import('../../components/rankings/rankings.module').then(m => m.RankingsModule),
    data: {
      breadcrumb: "Rankings",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/leadership',
    loadChildren: () => import('../../components/leadership/leadership.module').then(m => m.LeadershipModule),
    data: {
      breadcrumb: "Leadership",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/committes',
    loadChildren: () => import('../../components/committes/committes.module').then(m => m.CommittesModule),
    data: {
      breadcrumb: "Committes"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/curriculum-enhancement',
    loadChildren: () => import('../../components/curriculum-enhancement/curriculum-enhancement.module').then(m => m.CurriculumEnhancementModule),
    data: {
      breadcrumb: "Curriculum Enhancement"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/lectures-workshops',
    loadChildren: () => import('../../components/lectures-workshops/lectures-workshops.module').then(m => m.LecturesWorkshopsModule),
    data: {
      breadcrumb: "Lectures Workshops"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/mentoring-advising',
    loadChildren: () => import('../../components/mentoring-advising/mentoring-advising.module').then(m => m.MentoringAdvisingModule),
    data: {
      breadcrumb: "Mentoring Advising"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/student-innovations',
    loadChildren: () => import('../../components/student-innovations/student-innovations.module').then(m => m.StudentInnovationsModule),
    data: {
      breadcrumb: "Student Innovations"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/coe',
    loadChildren: () => import('../../components/coe/coe.module').then(m => m.CoeModule),
    data: {
      breadcrumb: "Calendar Of Events"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/research-hkbk',
    loadChildren: () => import('../../components/research-hkbk/research-hkbk.module').then(m => m.ResearchHkbkModule),
    data: {
      breadcrumb: "Research Hkbk"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/hr-development',
    loadChildren: () => import('../../components/hr-development/hr-development.module').then(m => m.HrDevelopmentModule),
    data: {
      breadcrumb: "Human Resource Development"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/summer-internships',
    loadChildren: () => import('../../components/summer-internships/summer-internships.module').then(m => m.SummerInternshipsModule),
    data: {
      breadcrumb: "Summer Internships"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/summer-internships-heading',
    loadChildren: () => import('../../components/summer-internships-heading/summer-internships-heading.module').then(m => m.SummerInternshipsHeadingModule),
    data: {
      breadcrumb: "Summer Internships Heading"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/balance-sheet',
    loadChildren: () => import('../../components/balance-sheet/balance-sheet.module').then(m => m.BalanceSheetModule),
    data: {
      breadcrumb: "Balance Sheet"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/industry-visits',
    loadChildren: () => import('../../components/industry-visits/industry-visits.module').then(m => m.IndustryVisitsModule),
    data: {
      breadcrumb: "Industry Visits"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/admissions-overview',
    loadChildren: () => import('../../components/admissions-overview/admissions-overview.module').then(m => m.AdmissionsOverviewModule),
    data: {
      breadcrumb: "Admissions Overview"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/footer',
    loadChildren: () => import('../../components/footer/footer.module').then(m => m.FooterModule),
    data: {
      breadcrumb: "Footer"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/studentstories',
    loadChildren: () => import('../../components/studentstories/studentstories.module').then(m => m.StudentstoriesModule),
    data: {
      breadcrumb: "Studentstories",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/campus',
    loadChildren: () => import('../../components/campus/campus.module').then(m => m.CampusModule),
    data: {
      breadcrumb: "Campus",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/facility',
    loadChildren: () => import('../../components/facility/facility.module').then(m => m.FacilitiyModule),
    data: {
      breadcrumb: "Facility",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/facilitiesoverview',
    loadChildren: () => import('../../components/facilitiesoverview/facilitiesoverview.module').then(m => m.FacilitiesoverviewModule),
    data: {
      breadcrumb: "Campus",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/homeranksection',
    loadChildren: () => import('../../components/homeranksection/homeranksection.module').then(m => m.HomeRankSectionModule),
    data: {
      breadcrumb: "Home Rank Section",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/filespath',
    loadChildren: () => import('../../components/files-path/files-path.module').then(m => m.FilespathModule),
    data: {
      breadcrumb: "Files Path",
      // roles: [Role.Admin],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/homeslider',
    loadChildren: () => import('../../components/home-slider/home-slider.module').then(m => m.HomeSliderModule),
    data: {
      breadcrumb: "Home Slider",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/institutionsslider',
    loadChildren: () => import('../../components/institutions-slider/institutions-slider.module').then(m => m.InstitutionsSliderModule),
    data: {
      breadcrumb: "Institutions Slider",
      // roles: [Role.Admin]
    },
    canActivate: [AuthGuard],
  },
  /* {
    path: 'adminhkbkcms/rankingheading',
    loadChildren: () => import('../../components/rankings-heading/rankings-heading.module').then(m => m.RankingsHeadingModule),
    data: {
      breadcrumb: "Ranking Recognition Heading"
    },
    canActivate: [AuthGuard],
  }, */
  {
    path: 'adminhkbkcms/iqacheading',
    loadChildren: () => import('../../components/iqacheading/iqacheading.module').then(m => m.IqacHeadingModule),
    data: {
      breadcrumb: "IQAC Heading",
      // roles: [Role.NAAC, Role.Admin],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/iqacsubheading',
    loadChildren: () => import('../../components/iqac-subheading/iqac-subheading.module').then(m => m.IqacSubHeadingModule),
    data: {
      breadcrumb: "IQAC Sub Heading",
      // roles: [Role.NAAC, Role.Admin],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/iqaccontent',
    loadChildren: () => import('../../components/iqac-content/iqac-content.module').then(m => m.IqacContentModule),
    data: {
      breadcrumb: "IQAC Content",
      // roles: [Role.NAAC, Role.Admin],
    },
    canActivate: [AuthGuard],
  },
    {
      path: 'adminhkbkcms/innovationheading',
      loadChildren: () => import('../../components/innovationheading/innovationheading.module').then(m => m.InnovationHeadingModule),
      data: {
        breadcrumb: "Innovation Heading",
        // roles: [Role.NAAC, Role.Admin],
      },
      canActivate: [AuthGuard],
    },
    {
      path: 'adminhkbkcms/innovationsubheading',
      loadChildren: () => import('../../components/innovation-subheading/innovation-subheading.module')
      .then(m => m.InnovationSubHeadingModule),
      data: {
        breadcrumb: "Innovation Sub Heading",
        // roles: [Role.NAAC, Role.Admin],
      },
      canActivate: [AuthGuard],
    },
    {
      path: 'adminhkbkcms/innovationcontent',
      loadChildren: () => import('../../components/innovation-content/innovation-content.module').then(m => m.InnovationContentModule),
      data: {
        breadcrumb: "Innovation Content",
        // roles: [Role.NAAC, Role.Admin],
      },
      canActivate: [AuthGuard],
      },

  {
    path: 'adminhkbkcms/iic',
    loadChildren: () => import('../../components/institute-industry-connect/institute-industry-connect.module').then(m => m.IICModule),
    data: {
      breadcrumb: "Institute Industry Connect",
      // roles: [Role.Admin],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/learning-resources',
    loadChildren: () => import('../../components/learning-resources/learning-resources.module').then(m => m.LearningResourcesModule),
    data: {
      breadcrumb: "Learning Resources",
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/learning-resources-uploads',
    loadChildren: () => import('../../components/learning-resources-uploads/learning-resources-uploads.module').then(m => m.LearningResourcesUploadsModule),
    data: {
      breadcrumb: "Learning Resources Uploads",
      // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/media',
    loadChildren: () => import('../../components/media/media.module').then(m => m.MediaModule),
    data: {
      breadcrumb: "Media",
      // // roles: [Role.Admin, Role.CivilEngineering,Role.ComputerScienceEngineering,Role.Degree,Role.ElectronicsEngineering,Role.InformationScienceEngineering,Role.MechanicalEngineering,Role.NAAC, Role.Placement],
    },
    canActivate: [AuthGuard],
  },
  /* {
    path: 'adminhkbkcms/menus',
    loadChildren: () => import('../../components/menus/menus.module').then(m => m.MenusModule),
    data: {
      breadcrumb: "Menus"
    },
    canActivate: [AuthGuard],
  }, */
  {
    path: 'adminhkbkcms/users',
    loadChildren: () => import('../../components/users/users.module').then(m => m.UsersModule),
    data: {
      breadcrumb: "Users",
      // // roles: [Role.Admin],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/settings',
    loadChildren: () => import('../../components/setting/setting.module').then(m => m.SettingModule),
    data: {
      breadcrumb: "Settings"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/institutions-info',
    loadChildren: () => import('../../components/institutions-info/institutions-info.module').then(m => m.InstitutionsInfoModule),
    data: {
      breadcrumb: "Settings"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/education-loan',
    loadChildren: () => import('../../components/education-loan/education-loan.module').then(m => m.EducationLoanModule),
    data: {
      breadcrumb: "Education Loan"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/scholarships',
    loadChildren: () => import('../../components/scholarships/scholarships.module').then(m => m.ScholarshipsModule),
    data: {
      breadcrumb: "Scholarships"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/seo-cource-page',
    loadChildren: () => import('../../components/seo-cource-page/seo-cources.module').then(m => m.SeoCourcePageModule),
    data: {
      breadcrumb: "Seo Cources"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/seo-course-page-faq',
    loadChildren: () => import('../../components/seo-course-page-faq/seo-course-page-faq.module').then(m => m.SeoCoursePageFaqModule),
    data: {
      breadcrumb: "Seo Cources Faq"
    },
    canActivate: [AuthGuard],
  },
  /* {
    path: 'adminhkbkcms/vendors',
    loadChildren: () => import('../../components/vendors/vendors.module').then(m => m.VendorsModule),
    data: {
      breadcrumb: "College"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/localization',
    loadChildren: () => import('../../components/localization/localization.module').then(m => m.LocalizationModule),
    data: {
      breadcrumb: "Localization"
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/reports',
    loadChildren: () => import('../../components/reports/reports.module').then(m => m.ReportsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'adminhkbkcms/invoice',
    loadChildren: () => import('../../components/invoice/invoice.module').then(m => m.InvoiceModule),
    data: {
      breadcrumb: "Invoice"
    },
    canActivate: [AuthGuard],
  }, */
];
